// Block Accordion
document.addEventListener("DOMContentLoaded", function () {
    const accordionButtons = document.querySelectorAll(".block-accordion .accordion-button");

    accordionButtons.forEach(button => {
      button.addEventListener("click", function () {
        const accordionItem = this.parentElement;
        const content = document.getElementById(this.dataset.accordion);

        if (accordionItem.classList.contains("active")) {
          accordionItem.classList.remove("active");
          content.style.display = "none";
        } else {
          document.querySelectorAll(".block-accordion .accordion-item").forEach(item => {
            item.classList.remove("active");
            item.querySelector(".block-accordion .accordion-content").style.display = "none";
          });

          accordionItem.classList.add("active");
          content.style.display = "block";
        }
      });
    });
  });


// Block product tabs
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".block-product-tabs .tab-button");
  const contents = document.querySelectorAll(".block-product-tabs .text-container");

  // Make the first text-container's immediate parent active by default
  if (contents.length > 0) {
    contents[0].classList.add("tab-active");
    contents[0].parentElement.classList.add("parent-active");
  }

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      // Remove "tab-active" from all buttons and contents
      buttons.forEach(btn => btn.classList.remove("tab-active"));
      contents.forEach(content => {
        content.classList.remove("tab-active");
        content.parentElement.classList.remove("parent-active"); // Remove from parent
      });

      // Add "tab-active" to clicked button and corresponding text-container
      this.classList.add("tab-active");
      const targetContent = document.getElementById(this.dataset.tab);
      targetContent.classList.add("tab-active");

      // Add "parent-active" to the immediate parent of .text-container
      targetContent.parentElement.classList.add("parent-active");
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {

    var menuButton = document.querySelector('.header__icon-list '); // Adjust selector for your menu button
    var firstCollapsible = document.querySelector('collapsible-content'); // Get the first collapsible submenu

    if (menuButton && firstCollapsible) {
        menuButton.addEventListener('click', function () {
            // Close all submenus
            document.querySelectorAll('collapsible-content').forEach(function (item) {
                item.open = false;
            });

            // Open only the first submenu
            firstCollapsible.open = true;
        });
    }
});



